import lozad from 'lozad';
import bus from '../utils/eventBus';

const lazy = () => {
  const lazyEl = document.querySelector('.u-lazy');

  if (lazyEl) {
    const observer = lozad('.u-lazy', {
      rootMargin: '10px 0px',
      threshold: 0.1,
      loaded: function(el) {
        const imgWrapper = el.closest('.c-img');
          if(imgWrapper) {

          const placeholder = imgWrapper.querySelector('.c-img__placeholder');
          if(placeholder) {
            let bgImage = placeholder.style.backgroundImage;
            bgImage = bgImage.replace('url("','').replace('")','');

            if(bgImage.length > 0) {
              imgWrapper.classList.add('c-img--loaded');
            }
          }
        }
      }
    });
    const observe = () => observer.observe();
    observe();

    bus.on('schrittweiter-modal-loaded', () => observe());

    window.WP_Grid_Builder && WP_Grid_Builder.on('init', function (wpgb) {
      wpgb.facets.on('appended', () => observe());
    });

    document.addEventListener('DOMContentLoaded', () => observe, {
      once: true,
    });
  }
};

lazy();
